import React from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  return (
    <header className="bg-gradient-to-r from-tal-brown-600 via-tal-slate-700 to-tal-blue-700 shadow-lg sticky top-0 z-50">
      <nav className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center h-16">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center space-x-2 text-white hover:text-tal-brown-100 transition-colors"
          >
            <span className="text-2xl font-bold">Tales and Legends</span>
          </Link>
        </div>
      </nav>
    </header>
  );
};

export default Header;
